import React, { useEffect } from "react";
import Text from "../../../utils/Custom/text";
import CommonForm from "../../../utils/commonComponent/commonForm";
import { useParams } from "react-router-dom";
import { AddButton, CancelButton, DeleteButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import { toast } from "react-toastify";
import { getPermissions } from "../rbac/hasAccess";

const EditPriceMaster = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const [inputStates, setInputStates] = React.useState({});
  const [priceVariations, setPriceVariations] = React.useState([]);

  const addPriceVariation = () => {
    const newId = priceVariations.length + 1;
    setPriceVariations([...priceVariations, { id: newId, label: "", price: "" }]);
  };

  const updatePriceVariationLabel = (id, value) => {
    const updated = priceVariations.map((variation) =>
      variation.id === id ? { ...variation, label: value } : variation
    );
    setPriceVariations(updated);
  };

  const updatePriceVariationPrice = (id, value) => {
    const updated = priceVariations.map((variation) =>
      variation.id === id ? { ...variation, price: value } : variation
    );
    setPriceVariations(updated);
  };

  const deletePriceVariation = (id) => {
    const updated = priceVariations.filter((variation) => variation.id !== id);
    setPriceVariations(updated);
  };

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const inputFields = [
    {
      type: "Autocomplete",
      label: "Client",
      stateKey: "clientId",
      options: "clients",
      valueKey: "id",
      getOptionLabelKey: "companyName",
      disabled: params.id != 0,
    },
    {
      type: "Autocomplete",
      label: "Item Name",
      stateKey: "serviceTypeId",
      options: "inspectionItems",
      valueKey: "id",
      getOptionLabelKey: "subcategory",
      disabled: params.id != 0,
    },
    // { type: "TextField", label: "Rate", stateKey: "rate" },
    { type: "TextField", label: "Percentage of PO", stateKey: "poPercentage", inputType: "number" },
    { type: "TextField", label: "Expenses", stateKey: "expenses", inputType: "number" },
  ];

  const fetchpriceListDetails = async () => {
    try {
      const query = `select * from priceList where id = ${params.id}`;
      const [priceList] = await fetchQuery(query);
      setInputStates(priceList);

      if (priceList.priceVariation) {
        const variations = JSON.parse(priceList.priceVariation);
        // Ensure each variation has both label and price fields
        const updatedVariations = variations.map((variation, index) => ({
          id: variation.id || index + 1,
          label: variation.label || "",
          price: variation.price || ""
        }));
        setPriceVariations(updatedVariations);
      }
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  const onSubmit = () => {
    const payload = {
      ...inputStates,
      priceVariation: JSON.stringify(priceVariations),
    };

    const url =
      BASE_URL + `priceList${params.id !== "0" ? `/${params.id}` : ""}`;
    const request =
      params.id !== "0"
        ? axiosWithToken.patch(url, payload)
        : axiosWithToken.post(url, payload);

    request
      .then(() => {
        toast.success(
          params.id !== "0"
            ? "Price Updated Successfully!"
            : "Price Created Successfully!"
        );
        setTimeout(window.location.reload(), 500);
      })
      .catch((error) => console.error("Submit error:", error));
  };

  useEffect(() => {
    if (params.id != 0) fetchpriceListDetails();
  }, [params]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Price" : `Update Price`}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <div className="mb-4">
        <AddButton
          onClick={addPriceVariation}
          label={" Add Price Variation"}
        />
        {priceVariations.map((variation) => (
          <div key={variation.id} className="my-2 flex gap-5">
            <input
              type="text"
              className="w-[40%] border border-blue-200 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500"
              placeholder="Enter variation"
              value={variation.label || ""}
              onChange={(e) =>
                updatePriceVariationLabel(variation.id, e.target.value)
              }
            />
            <input
              type="text"
              className="w-[40%] border border-blue-200 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500"
              placeholder="Enter price"
              value={variation.price || ""}
              onChange={(e) =>
                updatePriceVariationPrice(variation.id, e.target.value)
              }
            />
            {(permissions.delete || permissions.allAccess) && (
              <DeleteButton id="btn-delete" outline
                onClick={() => deletePriceVariation(variation.id)}
              />
            )}
          </div>
        ))}
      </div>
      <br />

      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.create || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditPriceMaster;
